import { Skeleton } from '@/components/ui/skeleton'
import {
  DutyCard,
  DutyCardContent,
  DutyCardHeader,
} from '@/features/duties/components/cards/shared/DutyCard'

/** Card-shaped placeholder for the eval detail page while the case loads. */
export function EvalCardSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <DutyCard>
      <DutyCardHeader title={<Skeleton className="h-4 w-32" />} />
      <DutyCardContent>
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton key={index} className="h-4 w-full" />
        ))}
      </DutyCardContent>
    </DutyCard>
  )
}
